webClient.controller('AirBookingDetails', ['$scope', '$window', '$timeout', '$i18next', 'tseApiClient', 'tseUtil', 'tseAirResultsHelper', 'trackingService',
    function ($scope, $window, $timeout, $i18next, tseApiClient, tseUtil, airHelper, trackingService) {
        $scope.getText = function (key) { return $window.culture.texts[key]; };

        //RestApi client object
        var apiClient = tseApiClient.createClient($window.site.apiUrl, $window.site.apiUrlSSL);
        //apiClient.enableDebug();    //Only for debugging....
        window.airHelper = airHelper;

        //Set the current login information
        $scope.loginInfo = $window.site.loginInfo;
        if ($scope.loginInfo != null && $scope.loginInfo.Agent) {
            $scope.agentId = $scope.loginInfo.Agent.AgentId;
        } else {
            $scope.agentId = null;
        }
        //$scope.clientId = $scope.loginInfo.Client.AccountNumber;
        //$scope.loginId = $scope.loginInfo.LoginId;
        $scope.showDetail = null;
        $scope.siteType = $window.site.type;
        $scope.enableOldResa = $window.enableOldResa;
        $scope.partnerId = $window.site.partnerId;
        $scope.partnerName = $window.partnerName;
        $scope.enableBrandedFares = $window.enableBrandedFares;
        $scope.enableContactForm = $window.enableContactForm;
        $scope.enablePostBookingInsurance = $window.enablePostBookingInsurance;
        if ($window.isAirbus) $scope.isAirbus = $window.isAirbus;
        $scope.isServair = $window.isServair;
        $scope.hideInvoices = $window.hideInvoices;

        $scope.login = { reference: '', email: '' };
        $scope.detailError = false;
        $scope.modified = false;
        $scope.isCrossFaring = false;
        $scope.paxType = {};
        $scope.paxType["ADT"] = "Adulte";
        $scope.paxType["CNN"] = "Enfant";
        $scope.paxType["INF"] = "Bébé";
        $scope.containsHotel = false;

        $scope.currentCabinClass = null;

        $scope.enableUpSellProducts = $window.enableUpSellProducts || $window.sessionStorage.getItem('forceUpsell') === 'true';

        //Open the modal with the key provided
        $scope.openModal = function (key) {
            if (key) {
                $timeout(function () {
                    $('[data-remodal-id=' + key + ']').remodal().open();
                },
                    200,
                    false);
            }
        };

        //Prepare the object to display in the Taxes Modal
        $scope.prepareTaxesDetailModal = function (key, paxType, fareItem, quantity) {
            $scope.displayTaxesDetailModal = false;
            if (fareItem) {
                var faresTaxes = airHelper.prepareTaxesObjectForBkgDetails(fareItem);

                if (faresTaxes) {

                    var taxesDetailsObject = {
                        paxtype: paxType,
                        key: key,
                        paxnumber: quantity,
                        fares: faresTaxes
                    };

                    $scope.modalTaxesKey = taxesDetailsObject.key;
                    $scope.modalTaxesPaxType = taxesDetailsObject.paxtype;
                    $scope.modalTaxesPaxFares = taxesDetailsObject.fares;
                    $scope.modalTaxesPaxNumber = taxesDetailsObject.paxnumber;

                    $scope.$broadcast("updateTaxesDetailModalData",
                        {
                            key: $scope.modalTaxesKey,
                            paxType: $scope.modalTaxesPaxType,
                            fares: $scope.modalTaxesPaxFares,
                            paxnumber: $scope.modalPaxNumber
                        });

                    $scope.displayTaxesDetailModal = true;

                    $scope.openModal('taxes-detail-modal-' + $scope.modalTaxesKey + '-' + $scope.modalTaxesPaxType);

                } else
                    return;
            }
        };

        //Get City Name or Iata: 
        //@desc this function returns the city name or airport name. In case of name undefined it returns airportIata
        $scope.getCityNameOrIata = function (airportIata) {
            if ($scope.view.airports[airportIata].cityIata) {
                if ($scope.view.cities[$scope.view.airports[airportIata].cityIata])
                    return $scope.view.cities[$scope.view.airports[airportIata].cityIata].name;
            }
            else {
                if ($scope.view.airports[airportIata].name)
                    return $scope.view.airports[airportIata].name;
                else
                    return airportIata;
            }
        };

        //Get Terminal name
        $scope.getTerminalDisplayName = function (airport, terminal) {
            if ($scope.view.airports && $scope.view.airports[airport]) {
                $scope.listTerminalsAux = $scope.view.airports[airport].terminal;
                if ($scope.listTerminalsAux) {
                    $scope.listTerminalsAux = $scope.listTerminalsAux.groupByKey('code');
                    if ($scope.listTerminalsAux[terminal])
                        return terminalDisplayName = $scope.listTerminalsAux[terminal].name;
                }
            }
        };

        //Get booking details by bookingId
        //@desc this function gets booking details and prepares the information of alerts or warnings concerns to flight details, it also prepare branded fare information if there is in the booking
        $scope.getBookingDetails = function (bookingId) {
            $window.FLoading({ vAction: 'show' });
            apiClient.AIR.getBookingDetails([bookingId]).success(function (data) {
                if (data && data.status == 0) {
                    setTimeout(function () {
                        $window.scrollTo(0, 0);
                    }, 100);
                    if (data.equipments.length == 1 && data.equipments[0].type == "TRN") $scope.isTrainOnly = true;
                    else if (data.equipments.length > 1) {
                        var isTrainOnly = false;
                        for (var i = 0; i < data.equipments.length; i++) {
                            if (data.equipments[i].type == "TRN") isTrainOnly = true;
                            else if (data.equipments[i].type != "TRN") {
                                isTrainOnly = false;
                                break;
                            }
                        }
                        $scope.isTrainOnly = isTrainOnly;
                    }
                    $scope.showDetail = true;
                    $scope.view = airHelper.getViewForBookingDetailsEntityVersion2(data);
                    if ($window.site.partnerId == "servair") {

                        var firstPaymentSubvention = null;
                        $scope.view.payments.forEach(function (payment) {
                            var found = false;
                            if (payment.paymentMode == 0 && !found) {
                                firstPaymentSubvention = payment;
                                found = true;
                            }
                        });
                        //cumul de tout les montants de subventions
                        if (firstPaymentSubvention) {
                            firstPaymentSubvention.amount = $scope.view.payments.filter(function (x) { return x.paymentMode == 0; }).sum(function (x) { return x.amount });
                            $scope.view.payments = $scope.view.payments.filter(function (x) { return x.paymentMode != 0; });
                            $scope.view.payments.unshift(firstPaymentSubvention);
                        }


                        $window.Typescript.Servair.Services.ServairService.getReservationSubvention(bookingId).then(function (result) {
                            $scope.view.subventionData = JSON.parse(result.data);
                            $scope.modified = $scope.view.subventionData.some(function (x) { return x.modified });
                            $scope.$apply();
                        })

                    } else {
                        $scope.view.subventionData = [];
                    }
                    //sort paxes if first one is not an adult
                    if ($scope.view.paxes[0].paxType !== 0) {
                        $scope.view.paxes.reverse();
                    }

                    $scope.view.invoices = [];
                    apiClient.AIR.getInvoicesList(bookingId).success(function (data) {
                        $scope.view.invoices = data.grep(function (i) { return (i.number != null) });
                    });
                    apiClient.AIR.getETicketsList(bookingId).success(function (data) {
                        $scope.view.etickets = data;
                    });
                    $window.Typescript.ETickets.Services.ETicketsService.getEticketsTrain(bookingId, $scope.view.bookingNumber).then(function (axiosResponse) {
                        $scope.view.eticketstrain = axiosResponse.data;
                        $scope.$apply();
                    }, function (err) {

                    });
                    $scope.$broadcast("onBookingSummaryUpdate");

                    //Start here: CrossFaring
                    $scope.isCrossFaring = $scope.view._innerData.bookings[0] && $scope.view._innerData.bookings[0].pnrs.length > 1;
                    //End here

                    //free flex
                    var flexies = $scope.view._innerData.bookings[0].flexies[0];
                    if (flexies) {
                        $scope.enableFreeFlex = (flexies.type === "FreeFlex" || flexies.type === 1);
                        $scope.totalFlexSelected = (flexies.type === "TotalFlex" || flexies.type === 2);
                        $scope.totalFlex75 = (flexies.type === "Flex75" || flexies.type === 3);
                        $scope.view.isFlexy = (flexies.type === "Flexy" || flexies.type === 0);
                        $scope.pricePerAdult = flexies.gross;
                        $scope.totalPrice = 0;

                        var f = $scope.view.fares.items.filter(function (f) { return f.type === 10; });
                        for (var j = 0; j < f.length; j++) {
                            $scope.totalPrice += f.amount * f.quantity;
                        }
                    }

                    var fares = $scope.view.fares.items.filter(function (f) { return f.type === 41; });

                    fares.each(function (fare) {
                        if ($scope.totalFlexSelected) {
                            fare.name = "Total Flex";
                        }
                        else if ($scope.enableFreeFlex) {
                            fare.name = "Free Flex";
                            fare.isFree = true;
                        }
                    });

                    var insurances = $scope.view.fares.items.filter(function (f) { return f.type === 40; });

                    insurances.each(function (insurance) {
                        if (insurance.subtype === 34 && ($scope.totalFlexSelected || $scope.enableFreeFlex)) {
                            insurance.name = getT('airbooking.repatriationins');
                        }
                    });



                    //Insurances
                    if ($scope.view.insurances) {
                        $scope.view.insurances.each(function (insurance) {
                            if (insurance.companyReference == 2 && insurance.insuranceReference == 2)
                                insurance.displayName = "Pack multirisques";
                            else
                                insurance.displayName = insurance.insuranceName;
                        });
                    }

                    if ($window.isAirbus) {
                        //Airbus additional datas
                        if ($scope.view.bookingAdditionalData) {
                            if ($scope.view.bookingAdditionalData["airbus.insurance"]) {
                                $scope.airbusInsurance = $scope.view.bookingAdditionalData["airbus.insurance"].value;
                            }

                            if ($scope.view.bookingAdditionalData["airbus.referrer"]) {
                                $scope.airbusReferrer = $scope.view.bookingAdditionalData["airbus.referrer"].value;
                            }
                        }
                    }

                    //Start here: branded fares
                    $scope.hasBrandedFare = $scope.view &&
                        $scope.view._innerData.bookings[0] &&
                        $scope.view._innerData.bookings[0].pnrs &&
                        $scope.view._innerData.bookings[0].pnrs.any(function (item) {
                            if (item.brand && item.brand.brandServices && item.brand.brandServices.length > 0)
                                return true;
                        });

                    if ($scope.hasBrandedFare) {
                        $scope.brand = $scope.view._innerData.bookings[0].pnrs[0].brand;
                        $scope.brand.displayName = $scope.brand.displayName.capitalize();
                        $scope.brand.includedServices = [];
                        $scope.brand.brandServices.each(function (bService) {
                            if (bService.pricing == 0) {
                                if (bService.description) {
                                    bService.descriptionHtml = bService.description.replaceAll("\n", "<br/>");
                                }

                                bService.cssClass =
                                    (bService.rficGroup + (bService.rficSubGroup ? "-" + bService.rficSubGroup : ""))
                                        .toLowerCase();
                                $scope.brand.includedServices.push(bService);
                            }
                        });
                        $scope.hasIncludedBaggage = $scope.view.itineraries[0] &&
                            $scope.view.itineraries[0].baggages[0]
                            && $scope.view.itineraries[0].baggages[0].quantity > 0;
                    }

                    if ($scope.enableUpSellProducts === true && $scope.view._innerData.bookings[0].accommodations != null && $scope.view._innerData.bookings[0].accommodations.any()) {

                        $scope.containsHotel = true;
                        $.getScript("/global/js/widgets/mrfly-widget-accommodation-info.js").done(function () {
                            mrflyWidgets['mrfly-widget-accommodation-info'].locale = $window.lng.substring(0, 2);
                            mrflyWidgets['mrfly-widget-accommodation-info'].resources = i18next.store.data.dev.translation;
                            mrflyWidgets['mrfly-widget-accommodation-info'].accommodation = $scope.view._innerData.bookings[0].accommodations[0];
                            mrflyWidgets['mrfly-widget-accommodation-info'].siteType = window.site.type;
                        })
                            .fail(function (jqxhr, settings, exception) {
                                console.log(exception);
                            });

                        $.getScript("/global/js/widgets/mrfly-widget-accommodation-price-detail.js").done(function () {
                            mrflyWidgets['mrfly-widget-accommodation-price-detail'].resources = i18next.store.data.dev.translation;
                            mrflyWidgets['mrfly-widget-accommodation-price-detail'].booking = $scope.view._innerData.bookings[0];
                            mrflyWidgets['mrfly-widget-accommodation-price-detail'].siteType = window.site.type;

                        })
                            .fail(function (jqxhr, settings, exception) {
                                console.log(exception);
                            });
                    }
                    if ($scope.view.insurances.length === 0 && //no insurance added
                        $scope.isAirbus !== true && //not avalailable for airbus
                        $scope.enablePostBookingInsurance && //xml config ok
                        $scope.view.request.multi !== true && //no multi destination
                        ($scope.view.status === 1 || $scope.view.status === 2)) {//booking status ok (don't show on payment refused)

                        $timeout(function () { //required for FF

                            $.getScript("/global/js/widgets/mrfly-widget-insurance-reminder.js").done(function () {
                                    mrflyWidgets['mrfly-widget-insurance-reminder'].$refs.reminder.bookingId = bookingId;
                                    mrflyWidgets['mrfly-widget-insurance-reminder'].$refs.reminder.requestId = bookingId;
                                    mrflyWidgets['mrfly-widget-insurance-reminder'].$refs.reminder.todayDeparture = moment().format("YYYY/MM/DD") === moment($scope.view.itineraries[0].departureDate).format("YYYY/MM/DD");
                                    mrflyWidgets['mrfly-widget-insurance-reminder'].$refs.reminder.adtNumber = $scope.view.paxAmount[0];
                                    mrflyWidgets['mrfly-widget-insurance-reminder'].$refs.reminder.cnnNumber = $scope.view.paxAmount[1];
                                    mrflyWidgets['mrfly-widget-insurance-reminder'].$refs.reminder.infNumber = $scope.view.paxAmount[2];
                                    if ($scope.agentId != null)
                                        mrflyWidgets['mrfly-widget-insurance-reminder'].$refs.reminder.agentId = $scope.agentId;
                                    mrflyWidgets['mrfly-widget-insurance-reminder'].$refs.reminder.dataBind();
                            })
                            .fail(function (jqxhr, settings, exception) {
                                console.log(exception);
                            });

                        }, 300);
                    }

                    $.getScript("/Global/js/widgets/mrfly-widget-request-recap.js").done(function () {
                        console.log("Loading done");
                        //set params do mapping

                        var airSearchRequest = new window['Typescript']['Class']['AirSearchRequest']['AirSearchRequest']();

                        airSearchRequest.adultNumber = $scope.view.request.adults;
                        airSearchRequest.childNumber = $scope.view.request.childs;
                        airSearchRequest.infantNumber = $scope.view.request.infants;
                        airSearchRequest.isOneWay = $scope.view.request.oneWay;
                        airSearchRequest.isRoundTrip = $scope.view.request.roundTrip;
                        airSearchRequest.isOpenJaw = $scope.view.request.openJaw;
                        airSearchRequest.isMultiDestination = $scope.view.request.multi;

                        //Map itineraries
                        airSearchRequest.itineraries = [];
                        $scope.view.itineraries.forEach(function (itinerary) {
                            var ins = new window['Typescript']['Class']['AirSearchRequest']['AirSearchRequestItinerary']();

                            ins.date = itinerary.departureDate;

                            ins.departureAirportIata = itinerary.departure;
                            ins.departureCityIata = itinerary.origin;
                            ins.departureName = $scope.getCityNameOrIata(itinerary.departure);

                            ins.arrivalAirportIata = itinerary.arrival;
                            ins.arrivalCityIata = itinerary.destination;
                            ins.arrivalName = $scope.getCityNameOrIata(itinerary.arrival);

                            airSearchRequest.itineraries.push(ins);
                        });
                        mrflyWidgets['mrfly-widget-request-recap'].airSearchRequest = airSearchRequest;
                        mrflyWidgets['mrfly-widget-request-recap'].locale = $window.lng.substring(0, 2);
                        mrflyWidgets['mrfly-widget-request-recap'].language = $window.lng;
                        mrflyWidgets['mrfly-widget-request-recap'].resources = i18next.store.data.dev.translation;
                    });

                    //End here
                    $window.FLoading({ vAction: 'hide' });

                    //scroll to target
                    $timeout(function () {
                        var hash = $window.document.location.hash;
                        if ($(hash).length > 0) {
                            $(hash)[0].scrollIntoView();
                        }
                    }, 300);
                }
            });
        };
        //END Booking Details

        //Invoice Dowload
        $scope.getInvoiceDownloadLink = function (invoiceId, forceDownload, bookingNumber) {
            return apiClient.AIR.getInvoiceDownloadLink(invoiceId, forceDownload, bookingNumber);
        };

        //E-ticket Dowload
        $scope.getETicketDownloadLink = function (invoiceId, forceDownload, bookingNumber) {
            return apiClient.AIR.getETicketDownloadLink(invoiceId, forceDownload, bookingNumber);
        };

        //************************** Receipt of Payment
        //Dìsplay Send Receipt Option
        $scope.sendReceiptShow = function (index) {
            var value = $("#i-payment-receipt-" + index).get(0);
            FPop({ oTarget: value, iPop: 'i-receipt-pop-' + index, vStyle: 'classic' });
        };

        //Send Payment Receipt by Email: This function call sendMail transaction to send mail type: 'ReceiptOfPayment'
        $scope.sendReceipt = function (payment, index) {
            if (XLFormValid({ iCont: 'i-form-receipt-' + index })) {
                var pId = payment.paymentId;
                var pspId = payment.bankCards[0].paymentPspId;
                var bId = $scope.view.bookingId;
                var bNum = $scope.view.bookingNumber;
                var to = $("#i-receipt-email-" + index).val();
                var mail = { bookingId: bId, bookingNumber: bNum, paymentId: pId, paymentPspId: pspId, addressTo: to, type: "ReceiptOfPayment" };

                var okMSG = function () { XLConfirm({ vTitle: "Email envoyé", vTextYes: 'OK', vHideNo: true }); };
                var failMSG = function () { XLConfirm({ vTitle: "Erreur dans l'envoi de l'email, veuillez recommencer", vTextYes: 'OK', vHideNo: true }); };

                apiClient.sendMail(mail).success(function (response) {
                    if (response) okMSG();
                    else failMSG();
                    $("#i-receipt-email-" + index).val('');
                }).error(function () { failMSG(); });


                FPopHide({ iPop: 'i-receipt-pop-' + index });
            }
        };
        //************************** End Receipt of Payment

        //************************** Send Eticket
        //Display Send Eticket  Option
        $scope.sendEticketShow = function () {
            var value = $("#i-eticket").get(0);
            FPop({ oTarget: value, iPop: 'i-eticket-pop', vStyle: 'classic' });
        };

        //Send Eticket by email: This function call sendMail transaction to send mail type: 'Eticket'
        $scope.sendEticket = function () {
            if (XLFormValid({ iCont: 'i-form-eticket' })) {
                var bId = $scope.view.bookingId;
                var bNum = $scope.view.bookingNumber;
                var to = $("#i-eticket-email").val();
                var mail = { bookingId: bId, bookingNumber: bNum, addressTo: to, type: "ETicket" };

                var okMSG = function () { XLConfirm({ vTitle: "Email envoyé", vTextYes: 'OK', vHideNo: true }); };
                var failMSG = function () { XLConfirm({ vTitle: "Erreur dans l'envoi de l'email, veuillez recommencer", vTextYes: 'OK', vHideNo: true }); };

                apiClient.sendMail(mail).success(function (response) {
                    if (response) okMSG();
                    else failMSG();
                    $("#i-eticket-email").val('');
                }).error(function () { failMSG(); });

                FPopHide({ iPop: 'i-eticket-pop' });
            }
        };
        //************************** End Send Eticket

        //This is only for debug
        $window.$scope = $scope;
        $window.$scope.apiClient = apiClient;
        $window.$scope.tseUtil = tseUtil;

        //Get Details:
        //@desc this function set a window.location.search param and call handleLoad function to get booking details
        $scope.GetDetails = function () {
            window.location.search = "reference=" + $scope.login.reference + "&email=" + $scope.login.email;
            handleLoad();
        };

        //OnLoad
        //@desc this function check if there the information neccesary (reference and email) in window.location.search to call getBookingId transaction and call getBookingDetails function
        var handleLoad = function () {
            $scope.detailError = false;
            var hashValue = window.location.search;
            console.log("handle Load:" + hashValue);
            if (hashValue == "" || hashValue == "?") {
                $scope.showDetail = false;
                //$window.sendAnalytics('/BookingDetails/Login', 'Booking view Login');
                //Tracking
                try {
                    //GTM
                    if (trackingService.isActivated()) {
                        trackingService.pushPageData('/BookingDetails/Login', 'Booking view Login', lng, false);
                    }
                }
                catch (ex) {
                    console.log(ex.message);
                    $window.trackingError = ex.message;
                }
                $window.sendInspectlet("pageUrl", $window.getUrl('BookingDetails/Login'));
            }
            else {
                var reference = tseUtil.Location.getQueryStringVar("reference");
                var email = tseUtil.Location.getQueryStringVar("email").replaceAll("!", ".");
                console.log(" data: reference and email:" + reference + " - " + email);

                $window.FLoading({ vAction: 'show' });
                var crypt = tseUtil.Location.getQueryStringVar("crypt");
                if (crypt == "") {
                    $scope.apiClient.AIR.getBookingId(reference, email).success(function (data) {
                        $window.FLoading({ vAction: 'hide' });
                        if (data) {
                            $scope.showDetail = null;
                            $scope.getBookingDetails(data);
                            //$window.sendAnalytics('/BookingDetails/View', 'Booking view');
                            //Tracking
                            try {
                                //GTM
                                if (trackingService.isActivated()) {
                                    trackingService.pushPageData('/Flightsearch/Bookingwait', 'Booking wait', lng, false);
                                }
                            }
                            catch (ex) {
                                console.log(ex.message);
                                $window.trackingError = ex.message;
                            }
                            $window.sendInspectlet("pageUrl", $window.getUrl('BookingDetails/View'));
                        }
                        else {
                            $scope.showDetail = false;
                            $scope.detailError = true;
                        }
                    }).error(function (data) {
                        console.log("Error");
                        console.log(data);
                        $scope.showDetail = false;
                        $scope.detailError = true;
                    });



                }
                else {
                    $.ajax({
                        url: 'page/AirBookingDetails/BookingDetailsResponse',
                        type: 'get',
                        data: {
                            crypt: crypt,
                        },
                        success: function (data) {
                            $window.FLoading({ vAction: 'hide' });
                            if (data) {
                                $scope.showDetail = null;
                                $scope.getBookingDetails(data);
                                //$window.sendAnalytics('/BookingDetails/View', 'Booking view');
                                //Tracking
                                try {
                                    //GTM
                                    if (trackingService.isActivated()) {
                                        trackingService.pushPageData('/Flightsearch/Bookingwait', 'Booking wait', lng, false);
                                    }
                                }
                                catch (ex) {
                                    console.log(ex.message);
                                    $window.trackingError = ex.message;
                                }
                                $window.sendInspectlet("pageUrl", $window.getUrl('BookingDetails/View'));
                            }
                            else {
                                $scope.showDetail = false;
                                $scope.detailError = true;
                            }
                        }
                    }).error(function (data) {
                        console.log("Error");
                        console.log(data);
                        $scope.showDetail = false;
                        $scope.detailError = true;
                    });

                }






                ////$scope.apiClient.AIR.getBookingId(reference, email).success(function (data) {
                ////    $window.FLoading({ vAction: 'hide' });
                ////    if (data) {
                ////        $scope.showDetail = null;
                ////        $scope.getBookingDetails(data);
                ////        //$window.sendAnalytics('/BookingDetails/View', 'Booking view');
                ////        //Tracking
                ////        try {
                ////        //GTM
                ////            if (trackingService.isActivated()) {
                ////                trackingService.pushPageData('/Flightsearch/Bookingwait', 'Booking wait', lng, false);
                ////            }
                ////        }
                ////        catch (ex) {
                ////            console.log(ex.message);
                ////            $window.trackingError = ex.message;
                ////        }
                ////        $window.sendInspectlet("pageUrl", $window.getUrl('BookingDetails/View'));
                ////    }
                ////    else {
                ////        $scope.showDetail = false;
                ////        $scope.detailError = true;
                ////    }
                ////}).error(function (data) {
                ////    console.log("Error");
                ////    console.log(data);
                ////    $scope.showDetail = false;
                ////    $scope.detailError = true;
                ////});
            }
        };
        handleLoad();

        //GoToContactForm
        //@desc this function build the url to pass to contact form with the customer data
        $scope.goToContactForm = function (contactFormUrl) {
            if ($scope.view && $scope.view.bookingNumber && $scope.view._innerData && $scope.view._innerData.bookings && $scope.view._innerData.bookings[0]) {
                if ($scope.view._innerData.bookings[0].client) {
                    if ($scope.view._innerData.bookings[0].client.firstName && $scope.view._innerData.bookings[0].client.lastName && $scope.view._innerData.bookings[0].client.email) {
                        var finishUrl = "";
                        if (!contactFormUrl) {
                            if ($window.site.loginUrl.indexOf('?') > 0) contactFormUrl = $window.site.loginUrl.substring(0, $window.site.loginUrl.indexOf('?'));
                            else contactFormUrl = $window.site.loginUrl;
                            var lastChar = contactFormUrl.substr(-1);
                            if (lastChar !== '/') {
                                contactFormUrl = contactFormUrl + '/';
                            }
                            contactFormUrl = contactFormUrl + "page/contactus/contactform";
                        }
                        else if (contactFormUrl.indexOf("?") > 0) {
                            finishUrl = contactFormUrl + "&bkgN=" + $scope.view.bookingNumber + "&firstName=" + $scope.view._innerData.bookings[0].client.firstName + "&lastName=" + $scope.view._innerData.bookings[0].client.lastName + "&email=" + $scope.view._innerData.bookings[0].client.email;
                            window.location.href = finishUrl;
                        }
                        else {
                            finishUrl = contactFormUrl + "?bkgN=" + $scope.view.bookingNumber + "&firstName=" + $scope.view._innerData.bookings[0].client.firstName + "&lastName=" + $scope.view._innerData.bookings[0].client.lastName + "&email=" + $scope.view._innerData.bookings[0].client.email;
                            window.location.href = finishUrl;
                        }
                    }
                }
            }
        };

        $scope.getInsuranceName = function (insurance) {
            if (insurance.type === 'MultiRisk' ) {
                return $i18next.t('mrfly-widget-insurance-payment.subtitle');
            }
            else
                return insurance.name;
        };

        $scope.getInsurancePdf = function (insurance) {
            if ((insurance.companyReference === '00001' || insurance.companyReference === '00002') && insurance.reference === '00001') {
                return $window.getUrl('page/pdfviewer?pdfname=conditionsassuranceannulation');
            }
            else if ((insurance.companyReference === '00001' || insurance.companyReference === '00002') && insurance.reference === '00002') {
                return $window.getUrl('page/pdfviewer?pdfname=detailsgarantimultiinsurance');
            }
            else if ((insurance.companyReference === '00001' || insurance.companyReference === '00002') && insurance.reference === '00003') {
                return $window.getUrl('page/pdfviewer?pdfname=conditionsassurancerapatriement');
            }
            else if ((insurance.companyReference === '00001' || insurance.companyReference === '00002') && insurance.reference === '00005') {
                return $window.getUrl('page/pdfviewer?pdfname=conditionsassurancerapatriement_00005');
            }
            return null;
        };

        $scope.getInsuranceContractNumber = function (insurance) {
            return insurance.contractReference ;
        };
    }]);